module.exports = __webpack_public_path__ + "img/qiu.0be90990.jpeg";